module.exports = __webpack_public_path__ + "d186e2666838d3cd89d681dcd8c521bf.svg";